import { Buffer } from 'buffer';

// The native app opens sign-in with `featureName=signInAndSecurity`. This is the
// app's webview signal and must drive the mobile app id / consumer key wherever
// it appears — in the URL directly or inside the OAuth `state` payload, which is
// where it survives after B2C redirects away from the /signin-credentials path.
export const isSignInAndSecurityFeature = (search?: string | null): boolean => {
    if (!search) return false;

    const queryParams = new URLSearchParams(search);
    if (queryParams.get('featureName') === 'signInAndSecurity') return true;

    try {
        const stateParam = queryParams.get('state');

        if (!stateParam) return false;

        const stateObject: { state?: string } = JSON.parse(stateParam);

        if (!stateObject.state) {
            return false;
        }

        const buffer = Buffer.from(stateObject.state, 'base64').toString(
            'utf-8'
        );

        return buffer.includes('featureName=signInAndSecurity');
    } catch {
        return false;
    }
};

export const isWebviewFromSearch = (search?: string | null): boolean => {
    if (!search) return false;

    const queryParams = new URLSearchParams(search);
    if (queryParams.get('webview') === 'true') return true;
    if (queryParams.get('featureName') === 'signInAndSecurity') return true;

    try {
        const stateParam = queryParams.get('state');

        if (!stateParam) return false;

        const stateObject: { state?: string } = JSON.parse(stateParam);

        if (!stateObject.state) {
            return false;
        }

        const buffer = Buffer.from(stateObject.state, 'base64').toString(
            'utf-8'
        );

        return (
            buffer.includes('webview=true') ||
            buffer.includes('featureName=signInAndSecurity')
        );
    } catch {
        return false;
    }
};
